<template>
    <!-- TODO css -->
    <modal @close="modals.feedbackModal = false">
        <div v-if="screen === 'form'" style="text-align: left">
            <h3>Feedback Detail</h3>
            <div class="large-form">
                <div class="form-line">
                    <div class="form-field" style="width: 100%">
                        <label for="form-input-name">Customer</label>
                        <div class="form-static-field"><b>{{ registration.first_name }} {{ registration.last_name }}</b></div>
                        <div style="margin-top: -6px">{{ registration.email }}</div>
                    </div>
                </div>  
                
                <div class="form-line">
                    <div class="form-field" style="width: 100%">
                        <label for="form-input-name">Feedback Date</label>
                        <div class="form-static-field"><b>{{ registration.visited_at }}</b></div>
                    </div>
                </div>     
                
                <div class="form-line">
                    <div class="form-field" style="width: 100%">
                        <label for="form-input-name">Rating</label>
                        <div :class="'feedback-rating rating-'+registration.rating">{{ verbalRating(registration.rating) }}</div>
                    </div>
                </div>     
                
                <div class="form-line" v-if="registration.feedback">
                    <div class="form-field" style="width: 100%">
                        <label for="form-input-name">Feedback</label>
                        <div class="customer-feedback-text">{{ registration.feedback }}</div>
                    </div>
                </div>      

            </div>
            <div class="form-actions">
              <span class="ws-button ws-button-secondary" data-action="cancel" @click="modals.feedbackModal = false">Close</span>
            </div>
        </div>
        
        <!-- Loading -->
        <div v-else-if="screen === 'loading'">
            <div class="ws-form-processing"><div class="value-loader"></div><p>We're retrieving the feedback details. <br>Please give us a moment...</p></div>
        </div>
    </modal>
</template>

<script>
import Modal from "@/components/modals/Modal";

export default {
    name: "FeedbackModal",
    components: {Modal},
    props: {
        registration: Object,
    },
    data() {
        return {
            batch: {},
            screen: 'loading',
            rename: false,
        }
    },
    methods: {
        verbalRating(rating) {
			if (this.campaign.reviews && this.campaign.reviews.buttons && this.campaign.reviews.buttons[rating]) return this.campaign.reviews.buttons[rating];
			else return 'Unknown';
		}
    },
    async mounted() {
        this.screen = 'form';
    },
    computed: {
        campaign() {
            return this.$store.state.giftBoxCampaign.detail;
        },
        team() {
            return this.$store.state.team.detail;
        },
        modals() {
            return this.$store.state.modals;
        },
    }
}
</script>

<style scoped>

</style>